import styled from '@emotion/styled';
import { Badge } from '@mui/material';

interface IStyledBadgeProps {
  bgColor?: string;
}

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<IStyledBadgeProps>`
  margin-left: 4px;

  > span {
    background-color: ${({ bgColor }) => bgColor};
    transform: scale(2) translate(50%, -50%);
  }
`;
